export default {
    default: {
        title: 'Opps, algo deu errado.',
        text: 'Não foi possivel continuar, valide as informações e tente novamente.',
    },
    PermissionsInvalid: {
        title: 'Opps, Permissão inválida',
        text: 'Por favor informe o administrador o nome da permissão que esta tentando atualizar.',
    },
    ServerError: {
        title: 'Opps, algo deu errado!',
        text: 'Por favor informe o administrador',
    },
    SearchFilterAdvancedInvalidException: {
        title: 'Filtro invalido!',
        text: 'Não foi possivel localizar registros com o filtro informado, por favor verifique os filtros e pesquise novamente.',
    },
    AuthorizationException: {
        title: 'Confirme se está logado',
        text: 'Por favor, atualize a página e tente novamente!',
    },
    ActionNotAllowed: {
        title: 'Ação não permitida',
        text: 'Por favor, tente novamente ou entre em contato com o suporte!',
    },
    NotFoundSearchException: {
        title: 'Ops, algo deu erro',
        text: 'Não foi possivel realizar a busca, pois não encontramos os parametros. Por favor, tente novamente ou entre em contato com o suporte!',
    },
    NotFoundException: {
        title: 'Ops, algo deu erro',
        text: 'Não localizamos o registro que tentou pesquisar. Por favor, tente novamente!',
    },
    ExportExcellDataNull: {
        title: 'Não foi possivel realizar a exportação',
        text: 'Confirme se existe conteudo para serem exportados',
    },
    NotExportParametersFoundException: {
        title: 'Não foi possivel realizar a exportação',
        text: 'Erro ao receber os dados para serem exportados. Por favor, tente novamente ou entre em contato com o suporte!',
    },
    NoSaveException: {
        title: 'Não foi possível salvar os dados',
        text: 'Verifique se todos os campos estão correto',
    },
    RequestNotSupportedException: {
        title: 'Não foi acessar  conteudo',
        text: 'Esta solicitação não é compatível com o recurso.',
    },

    OperatingHoursInvalidException: {
        title: 'Acesso não permitido',
        text: 'Você não tem permissão para acessar o sistema neste horário!',
    },

    // Login
    LoginInvalidException: {
        title: 'Oppsss',
        text: 'Usuário e/ou senha inválidos. Por favor, verifique as informações inseridas e tente novamente!',
    },
    LoginSuccess: {
        title: 'Login realizado com sucesso!',
        text: 'Aguarde enquanto redirecionamos você à página inicial',
    },
    LoginUnauthenticated: {
        title: 'Oppsss...',
        text: 'Você deve estar logado para acessar essa página!',
    },

    // Register
    UserEmailAlreadyRegisteredException: {
        title: 'Oppsss',
        text: 'Este e-mail já está cadastrado em nosso sistema. Por favor, tente novamente com outro e-mail!',
    },
    InvalidPasswordInRegisterUserException: {
        title: 'Senha inválida',
        text: 'Use no mínimo 8 caracteres, uma letra maiúscula, um número e um caractere especial (!@#$%^&*).',
    },
    DocumentAlreadyRegisterException: {
        title: 'Atenção',
        text: 'Já existe um cadastro com o mesmo CPF/CNPJ. Por favor, tente novamente com outro documento!',
    },

    // Login
    login_SignatureBlockedException: {
        title: 'Oh não...',
        text: 'Solicite ao responsável da empresa para acionar o suporte e verificar sua assinatura!',
    },
}
